import React from 'react'
import { useLocation } from 'react-router-dom'
import styles from './registrationProgress.module.css'

const steps = [
  { id: 1, label: '1', path: '/registration/profile' },
  { id: 2, label: '2', path: '/registration/industries' },
  { id: 3, label: '3', path: '/registration/business' },
  { id: 4, label: '4', path: '/registration/upload-logo' },
]

function getActiveIndex(pathname: string) {
  const idx = steps.findIndex((s) => pathname.startsWith(s.path))
  return idx === -1 ? 0 : idx
}

export const RegistrationProgress: React.FC = () => {
  const location = useLocation()
  const activeIdx = getActiveIndex(location.pathname)

  return (
    <div className={styles.wrapper} aria-label="registration progress">
      {steps.map((step, index) => {
        const isActive = index === activeIdx
        const isCompleted = index < activeIdx
        const isLast = index === steps.length - 1
        return (
          <React.Fragment key={step.id}>
            <div className={styles.step} aria-current={isActive ? 'step' : undefined}>
              {isCompleted ? (
                <div className={styles.completed} aria-label={`Step ${step.id} completed`} />
              ) : (
                <div
                  className={`${styles.node} ${isActive ? styles.active : styles.idle}`}
                  aria-label={`Step ${step.id}${isActive ? ' current' : ''}`}
                  role="img"
                  aria-hidden={false}
                >
                  {step.label}
                </div>
              )}
            </div>
            {!isLast && <div className={`${styles.connector} ${index < activeIdx ? styles.connectorDone : styles.connectorIdle}`} />}
          </React.Fragment>
        )
      })}
    </div>
  )
}
